import { Component, OnInit, OnChanges, Input, ElementRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
@Component({
  selector: 'app-turns-desk-auto-reset-card',
  templateUrl: './turns-desk-auto-reset-card.component.html',
  styleUrls: ['./turns-desk-auto-reset-card.component.scss']
})
export class TurnsDeskAutoResetCardComponent implements OnInit, OnChanges {

  @Input() desk;
  updateDeskAutoResetInfoSubscription: Subscription;
  basicDataForm = new FormGroup({
    countAutoReset: new FormControl(false),
    initialCount: new FormControl({ value: null, disabled: true }),
    limitCount: new FormControl({ value: null, disabled: true })
  });

  constructor(private desksTurnsService: DesksTurnsService,
    private snackbarService: SnackBarService,
    private eRef: ElementRef) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.desk) {
      this.resetForm();
    }
  }

  public countAutoReset() {
    if (this.basicDataForm.get('countAutoReset').value) {
      this.basicDataForm.get('initialCount').enable();
      this.basicDataForm.get('limitCount').enable();
    } else {
      this.basicDataForm.get('initialCount').disable();
      this.basicDataForm.get('limitCount').disable();
    }
  }

  public inputChange() {
    if (this.basicDataForm.get('initialCount').dirty || this.basicDataForm.get('limitCount').dirty) {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackbarService.open(validation, 'error');
        this.resetForm();
      }
    }
  }

  public submitForm() {
      this.updateDeskAutoResetInfoSubscription = this.desksTurnsService.updateDeskAutoResetInfo(this.desk.InternalId, this.basicDataForm.get('countAutoReset').value, this.basicDataForm.get('initialCount').value, this.basicDataForm.get('limitCount').value).subscribe(
        (res) => {
          this.snackbarService.open('turns-page.snackbar messages.update desk success', 'success');
          this.desksTurnsService.refreshDesk();
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
  }

  public validateForm() {
    if (this.basicDataForm.get('countAutoReset').value && !this.basicDataForm.get('initialCount').value) {
      return 'turns-page.snackbar messages.initial count required error';
    } if (this.basicDataForm.get('countAutoReset').value && !this.basicDataForm.get('limitCount').value) {
      return 'turns-page.snackbar messages.limit count required error';
    } else if (parseInt(this.basicDataForm.get('limitCount').value, 10) < parseInt(this.basicDataForm.get('initialCount').value, 10)) {
      return 'turns-page.snackbar messages.limit lower than initial error';
    } else {
      return true;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      countAutoReset: this.desk.CountAutoReset,
      initialCount: this.desk.InitialCount,
      limitCount: this.desk.LimitCount
    });
    this.countAutoReset();
  }
}
